<template lang="pug">
  .k-item.body.denied( v-if='object.error_data' :class=`{ selected }` )
    i-lock.icon( title='Denied' )
    span.text Permission denied
  .k-item.body( v-else :class=`{ selected }` )
    .title
      w-btn-icon.selector( :class=`{ selected }` @click.prevent='select' )
        transition( name='fade' mode='out-in' )
          i-checked( v-if='selected' )
          i-unchecked( v-else )
      router-link.text(
        :to='`/admin/content/${ type }/${ object.slug || object.id }`'
      )
        span( v-html='title' )
    .info( v-if=`object.collections ||
                 Object.keys( actions ).length` )
      a.attribute.collection(
        href='#'
        v-for='collection in object.collections'
        @click.prevent
      )
        i-chevron-right.icon( decorative )
        span( v-html='collection.name' )
      k-actions-icons(
        :item='object'
        v-bind='{ model, actions, icons }'
      )
</template>

<script lang="js">
import KActionsIcons from '@/blocks/k-actions-icons'
import IUnchecked from 'icons/CheckboxBlankOutline'
import IChecked from  'icons/CheckboxMarkedOutline'
import WBtnIcon from '@/widgets/w-btn-icon'

export const mixin = {
  components: {
    KActionsIcons,
    IUnchecked,
    IChecked,
    WBtnIcon,
  },
  props: {
    model: {
      type: Object,
      default: () => ({})
    },
    object: {
      type: Object,
      default: () => ({})
    },
    actions: {
      type: Array,
      default: () => []
    },
    icons: {
      type: Object,
      default: () => ({})
    },
    selected: Boolean,
    selecting: Boolean,
  },
  methods: {
    refresh() {
      this.$emit( 'refresh' )
    },
    select() {
      this.$emit( 'select', this.object )
    }
  },
}

export default {
  name: 'ItemBlock',
  mixins: [ mixin ],
  components: {},
  props: {},
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {
    type() {
      if ( this.object.type === 'attachment' ) {
        return this.object.mime_type
           ? this.object.mime_type.split('/')[0]
           : 'file'
      }
      return this.object.type       // TODO: or some such
    },
    title() {
      return ( this.object.title && this.object.title.rendered ) ||
         this.object.name
    }
  }
}
</script>

<style lang="scss">
.k-item {
  .selector {
    margin-right: var(--s-sm);
    opacity: 0;
    &.selected {
      opacity: 1;
    }
  }
  .selector {
    margin-right: var(--s-sm);
    opacity: 0;
    &.selected {
      opacity: 1;
    }
  }
  &:hover, &.hover, &:focus, &.focus {
    .selector {
      opacity: 1;
    }
  }
  &.selected {
    background: rgba(0,0,0,0.03);
  }
}
</style>
